<template>
  <a-drawer :destroy-on-close="true" title="编辑" :visible="visible" :width="540" @close="closeDrawer">
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{
        span: 7,
        style: {
          textAlign: 'left'
        }
      }" :wrapperCol="{ span: 17 }">
      <a-form-model-item label="台账已接入" prop="asset_added">
        <a-input-number id="assetAddedInputNumber" v-model="form.asset_added" :min="0" />
      </a-form-model-item>

      <a-form-model-item label="台账需接入" prop="asset_waited">
        <a-input-number id="assetWaitedInputNumber" v-model="form.asset_waited" :min="0" />
      </a-form-model-item>

      <a-form-model-item label="数据库添加状态" prop="database_state">
        <a-radio-group v-model="form.database_state">
          <a-radio value="YES">是</a-radio>
          <a-radio value="NO">否</a-radio>
          <a-radio value="-">-</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="中间件添加状态" prop="middleware_state">
        <a-radio-group v-model="form.middleware_state">
          <a-radio value="YES">是</a-radio>
          <a-radio value="NO">否</a-radio>
          <a-radio value="-">-</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="关键日志接入状态" prop="key_log_state">
        <a-radio-group v-model="form.key_log_state">
          <a-radio value="YES">是</a-radio>
          <a-radio value="NO">否</a-radio>
          <a-radio value="-">-</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="业务日志接入状态" prop="service_log_state">
        <a-radio-group v-model="form.service_log_state">
          <a-radio value="YES">是</a-radio>
          <a-radio value="NO">否</a-radio>
          <a-radio value="-">-</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="接入状态" prop="access_state">
        <a-radio-group v-model="form.access_state">
          <a-radio value="PROCESSING">接入中</a-radio>
          <a-radio value="FINISHED">已完成</a-radio>
          <a-radio value="TIMEOUT">已超时</a-radio>
          <a-radio value="-">-</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="最新进展" prop="latest_progress">
        <a-textarea v-model="form.latest_progress" :rows="4" />
      </a-form-model-item>

      <a-form-model-item label="完成时限承诺" prop="promised_date">
        <a-date-picker v-model="form.promised_date" valueFormat="YYYY-MM-DD" />
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 17, offset: 7 }" style="margin-bottom: 0">
        <a-space size="middle">
          <a-button :loading="loading" type="primary" @click="ok">
            确定
          </a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>

    </a-form-model>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import { getServiceAccess, updateServiceAccess } from '@/api/boss'

export default {
  name: 'BuildInputDrawer',
  data () {
    return {
      visible: false,
      loading: false,
      detail: {
        id: ''
      },
      form: {
        asset_added: 0,
        asset_waited: 0,
        database_state: '',
        middleware_state: '',
        key_log_state: '',
        service_log_state: '',
        access_state: '',
        latest_progress: '',
        promised_date: undefined
      },
      rules: {
        asset_added: [{
          message: '请输入已接入台账数',
          required: true,
          trigger: 'change'
        }],
        asset_waited: [{
          message: '请输入已接入台账数',
          required: true,
          trigger: 'change'
        }],
        // promised_date: [{
        //   message: '请选择完成时限承诺时间',
        //   required: true,
        //   trigger: 'change'
        // }]
      }
    }
  },
  methods: {
    closeDrawer () {
      this.form = {
        asset_added: 0,
        asset_waited: 0,
        database_state: '',
        middleware_state: '',
        key_log_state: '',
        service_log_state: '',
        access_state: '',
        latest_progress: '',
        promised_date: undefined
      }
      this.$refs.form.resetFields()
      this.detail = {}
      this.visible = false
      this.loading = false
    },
    show (id) {
      getServiceAccess(id).then((res) => {
        this.detail = res.data
        this.form.asset_added = res.data.asset_added
        this.form.asset_waited = res.data.asset_waited
        this.form.database_state = res.data.database_state
        this.form.middleware_state = res.data.middleware_state
        this.form.key_log_state = res.data.key_log_state
        this.form.service_log_state = res.data.service_log_state
        this.form.access_state = res.data.access_state
        this.form.latest_progress = res.data.latest_progress
        this.form.promised_date = res.data.promised_date
      }).finally(() => {
        this.visible = true
      })
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            ...this.form
          }
          if (params.promised_date) params.promised_date = moment(params.promised_date).format('YYYY-MM-DD HH:mm:ss')
          // else params.promised_date = undefined
          updateServiceAccess(this.detail.id, params).then((res) => {
            this.$message.success(res.message)
            this.$emit('refresh')
            this.closeDrawer()
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
